import axios from '../plugins/axios'

const getCompliance = () => axios.get('/compliance/user')
const assignComplianceHours = hoursCompliance => axios.post('/compliance/hours', hoursCompliance)
const saveComplianceDetails = details => axios.post('/compliance/company/details', details)
const addUsersCompliance = usersCompliance => axios.post('/compliance/users', usersCompliance)
const getAssignedUsers = (id) => axios.get(`/compliance/company/users/${id}`)
const removeUserAssignment = id => axios.delete('/compliance/user', { data: { id } })
const createPlanTemplate = planTemplate => axios.post('/compliance/plan/template', planTemplate)
const getTemplatesPlans = () => axios.get('/compliance/plan/templates')
const getAllTemplatesPlans = () => axios.get('/compliance/plan/all/templates')
const assignPlanToCompany = planCompany => axios.post('/compliance/plan/company', planCompany)
const saveHoursReport = ReportHours => axios.post('/compliance/report/hour', ReportHours)
const tasksByUser = (companyId, status, activity, userId, startDate, endDate, skip, take, sortOrder) => axios.get('/compliance/hours/user', {
  params: { companyId, status, activity, userId, startDate, endDate, skip, take, sortOrder }
})
const tasksByUserExcel = (companyId, status, activity, userId, startDate, endDate, skip, take, sortOrder) => axios.get('/compliance/hours/user/excel', {
  params: { companyId, status, activity, userId, startDate, endDate, skip, take, sortOrder }
})
const getAnnualComplianceReport = (year) => axios.get('/compliance/report/annual', { params: { year } })
const getWeeklyUser = (userId) => axios.get(`/compliance/weekly/${userId}`)
const getMonthlyCompliance = (userId) => axios.get(`/compliance/monthly/${userId}`)
const getAnnualCompliance = (userId) => axios.get(`/compliance/annual/${userId}`)
const getUsersCompliance = () => axios.get('/compliance/users/admin')
const getComplianceByCompany = companyId => axios.get('/compliance/company/admin', { params: { companyId } })
const updateHoursReport = ReportHours => axios.put('/compliance/report/hour', ReportHours)
const updatePlan = plan => axios.put('/compliance/plan/template', plan)
const getUserComplianceCompanies = () => axios.get('/companies/user/compliance')
const deleteTaskByCompany = (taskId) => axios.patch(`/compliance/tasks/${taskId}/soft-delete`);
const getSubtasks = (taskId) => axios.get(`/compliance/tasks/${taskId}/subtasks`)

export {
  assignComplianceHours,
  saveComplianceDetails,
  getCompliance,
  addUsersCompliance,
  getAssignedUsers,
  removeUserAssignment,
  createPlanTemplate,
  getTemplatesPlans,
  getAllTemplatesPlans,
  assignPlanToCompany,
  saveHoursReport,
  tasksByUser,
  getWeeklyUser,
  getMonthlyCompliance,
  getAnnualCompliance,
  getUsersCompliance,
  getComplianceByCompany,
  updateHoursReport,
  updatePlan,
  getUserComplianceCompanies,
  tasksByUserExcel,
  getAnnualComplianceReport,
  deleteTaskByCompany,
  getSubtasks
}
